export function initNav() {
    const body = document.querySelector('body')
    const html = document.querySelector('html')
    const tabletResolution = window.screen.width <= 1024

    const navMenu = document.getElementById('navMenu')
    const openBtn = document.getElementById("navBtn") as HTMLButtonElement
    const openBtnMobile = document.getElementById("navBtnMobile") as HTMLButtonElement

    const userBtn = document.getElementById('userBtn') as HTMLButtonElement
    const userMenu = document.getElementById('userMenu')

    function setMenuOpen() {
        navMenu.classList.toggle('nav__menu--open')
        if (tabletResolution) {
            body.classList.toggle('overflow-hidden')
            html.classList.toggle('overflow-hidden')
        }
    }

    //Main Menu
    if (openBtn) {
        openBtn.addEventListener('click', () => {
            setMenuOpen()
        })
    }
    if (openBtnMobile) {
        openBtnMobile.addEventListener('click', () => {
            setMenuOpen()
        })
    }

    //User Menu
    if (userBtn) {
        userBtn.addEventListener('click', () => {
            userMenu.classList.toggle('user-menu__pop-up--open')
            if (tabletResolution) {
                body.classList.toggle('overflow-hidden')
                html.classList.toggle('overflow-hidden')
            }
        })
    }

    //Handle outside click
    document.addEventListener('mouseup', (e) => {
        if (navMenu.classList.contains('nav__menu--open')) {
            if (!navMenu.contains(e.target as Node) && e.target !== openBtn && e.target !== openBtnMobile) {
                navMenu.classList.remove('nav__menu--open')
                if (tabletResolution) {
                    body.classList.remove('overflow-hidden')
                    html.classList.remove('overflow-hidden')
                }
            }
        }
        if (userMenu) {
            if (userMenu.classList.contains('user-menu__pop-up--open')) {
                if (!userMenu.contains(e.target as Node) && e.target !== userBtn) {
                    userMenu.classList.remove('user-menu__pop-up--open')
                    if (tabletResolution) {
                        body.classList.remove('overflow-hidden')
                        html.classList.remove('overflow-hidden')
                    }
                }
            }
        }
    })
}